// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3FgMZ","requiredAsterisk":"Info_requiredAsterisk__1I0_e"};